module.exports = __webpack_public_path__ + "img/private-napolimania-pasta-1.e3dd0508.jpg";